const capitalizeWords = (text) => {
  return text
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

const breadCrumbList = (page) => {
  let parent = {};
  let child = null;
  let grandChild = null;

  const path = page?.url || ""; // Ensure the path is properly defined
  const segments = path.split("/").filter((segment) => segment);

  const checkPath = () => {
    if (segments[0] === "meet-our-team") return "about";
    return segments[0];
  };

  switch (checkPath()) {
    case "about":
      parent = { link: "/about", label: "About Us" };
      break;

    case "practice-areas":
      parent = { link: "/practice-areas", label: "Practice Areas" };
      break;

    case "personal-injury":
      parent = { link: "/personal-injury", label: "Personal Injuries" };
      break;

    case "accident-lawyer-new-york":
      parent = {
        link: "/accident-lawyer-new-york",
        label: "Accident Lawyer New York",
      };
      break;

    case "blogs":
      parent = { link: "/blogs", label: "Blogs" };
      break;

    case "reviews":
      parent = { link: "/reviews", label: "Reviews" };
      break;

    case "contact-us":
      parent = { link: "/contact-us", label: "Contact Us" };
      break;

    default:
      parent = null;
      child = null;
      grandChild = null;
      break;
  }

  segments?.map((segment, idx) => {
    if (idx === 1) {
      child = {
        link: `/${segments[0]}/${segment}`,
        label: capitalizeWords(segment.replace(/-/g, " ")),
      };
    } else if (idx === 2) {
      grandChild = {
        link: `/${segments[0]}/${segments[1]}/${segment}`,
        label: capitalizeWords(segment.replace(/-/g, " ")),
      };
    }
  });

  const breadCrumbs = {
    parent,
    child,
    grandChild,
  };

  return breadCrumbs;
};

export default breadCrumbList;
